import { render, staticRenderFns } from "./InformativeDialog.vue?vue&type=template&id=29b668dd&scoped=true"
import script from "./InformativeDialog.vue?vue&type=script&lang=js"
export * from "./InformativeDialog.vue?vue&type=script&lang=js"
import style0 from "./InformativeDialog.vue?vue&type=style&index=0&id=29b668dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b668dd",
  null
  
)

export default component.exports